export const tailMisc = {
  tabBottom: {
    checkins: `Check-ins`,
    checkinsProg: `Próximos`,
    requests: `Solicitações`,
  },
  adminNav: {
    myAccount: `Minha conta`,
  },
  loader: {
    title: `Criando {reason}!`,
    defaultReason: `acomodação`,
    preparing: `Estamos configurando sua {reason}, aguarde…`,
    calendar: `Configurando o calendário`,
    availability: `Verificando a disponibilidade`,
    prices: `Configurando os preços`,
    almostDone: `Quase lá, finalizando sua {reason}…`,
  },
};
